import { useEffect } from "react";

import { useAtom } from "jotai";

import { atom } from "jotai";
import { SizeProps } from "../types";

const sizeAtom = atom<(SizeProps & { saleSize?: number }) | undefined>(
  undefined
);

const useSize = (defaultValue?: SizeProps) => {
  const [size, setSize] = useAtom(sizeAtom);

  useEffect(() => {
    if (defaultValue) setSize(defaultValue);
    return () => setSize(undefined);
  }, []);

  return { size, setSize };
};

export default useSize;
